module.exports = __webpack_public_path__ + "img/sephora.16a5a31.svg";